import { render, staticRenderFns } from "./mdc-tab-bar.vue?vue&type=template&id=53f7f300&"
import script from "./mdc-tab-bar.vue?vue&type=script&lang=ts&"
export * from "./mdc-tab-bar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports